const validateStatus = (response: Response) => {
	return response.ok;
};

export default validateStatus;
